import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ScrollToTop from "@/components/layout/ScrollToTop";
import motion from "@/lib/lazy-motion-tags";
import { Helmet } from "react-helmet";
import IconLoader from "@/components/IconLoader";
import { Card } from "@/components/ui/card";
import ResponsiveImage from "@/components/ResponsiveImage";

const Products = () => {
  const products = [
    {
      iconName: "Home",
      image: 'Classic-interior-doors.jpg',
      title: "أبواب داخلية كلاسيك",
      description: "الخيار الأمثل للغرف والممرات",
      features: [
        "سطح أملس أو محزز حسب الطلب",
        "سماكة 35-40 ملم للمتانة القصوى",
        "متوفرة بـ+12 لون خشبي طبيعي",
        "قابلة للتخصيص بالكامل",
        "خفيفة الوزن وسهلة الفتح والإغلاق",
        "عزل صوتي ممتاز للخصوصية",
      ],
      uses: ["غرف النوم الرئيسية", "غرف الأطفال", "غرف الضيوف", "المكاتب المنزلية", "الممرات الداخلية"],
    },
    {
      iconName: "ShowerHead",
      image: 'Bathroom-Doors.png',
      title: "أبواب الحمامات",
      description: "مصممة خصيصاً لتحدي الماء والرطوبة",
      features: [
        "مقاومة 100% للماء - لا تنتفخ أو تتشوه",
        "مزودة بإطار ألمنيوم أو بلاستيكي عالي الجودة",
        "فتحات تهوية سفلية (اختياري)",
        "سطح مقاوم للبقع وسهل التنظيف",
        "لا تتعفن أو تتغير رائحتها",
        "ألوان ثابتة لا تتأثر بالبخار",
      ],
      uses: ["الحمامات الرئيسية", "حمامات الضيوف", "دورات المياه", "غرف الغسيل", "حمامات السباحة"],
    },
    {
      iconName: "Sparkles",
      image: 'doors.png',
      title: "أبواب ديكورية فاخرة",
      description: "عندما يلتقي الفن بالوظيفة",
      features: [
        "نقوش فنية دقيقة وتفاصيل فاخرة",
        "ألوان خشبية جذابة (ماهوغني، بلوط، جوز)",
        "تصاميم عصرية وكلاسيكية",
        "مظهر أنيق يضاهي أفخر أنواع الخشب",
        "طابع فاخر يعكس الذوق الرفيع",
      ],
      uses: ["المجالس الرسمية", "مكاتب المديرين", "غرف الاستقبال", "القصور والفلل", "الفنادق والبنوك"],
    },
        {
      iconName: "Box",
      image: 'Earless_doors.png',
      title: "أبواب بدون حلق",
      description: "التصميم العصري بأبسط أشكاله",
      features: [
        "تصميم عصري وأنيق",
        "تركيب سهل وصيانة بسيطة",
        "يوفر في المساحة",
        "متناسقة مع التصاميم الداخلية المعاصرة",
        "خطوط بسيطة ونظيفة",
        "تكلفة تركيب أقل",
      ],
      uses: ["المنازل الحديثة", "المكاتب العصرية", "الشقق الصغيرة", "المساحات المفتوحة"],
    },
    {
      iconName: "Hammer",
      image: 'cnc.png',
      title: "أبواب CNC محفورة",
      description: "تكنولوجيا CNC لتفاصيل لا مثيل لها",
      features: [
        "تفاصيل دقيقة وعميقة",
        "تصاميم هندسية محفورة (إسلامية، جيومتريك، معاصرة)",
        "طابع فاخر وحديث",
        "إمكانية التخصيص الكامل للتصميم",
      ],
      uses: ["المداخل الفاخرة", "القصور والفيلا", "اللوبيات الفندقية", "المساحات التجارية الراقية"],
    },
  ];

  const customization = [
    { title: "المقاسات", description: "أي مقاس تحتاجه (قياسي أو مخصص)" },
    { title: "الألوان", description: "اختر من بين +15 لون خشبي طبيعي" },
    { title: "التصميم", description: "من الكتالوج أو تصميم خاص بك" },
    { title: "الإكسسوارات", description: "مقابض، أقفال، وإكسسوارات فاخرة" },
    { title: "الزجاج", description: "إضافة زجاج ديكوري (اختياري)" },
  ];

  return (
    <>
      <ScrollToTop />
      <Helmet>
        <title>منتجاتنا - أبواب WPC | داخلية، حمامات، ديكورية، CNC محفورة</title>
        <meta name="description" content="تصفح مجموعتنا الواسعة من أبواب WPC: أبواب داخلية كلاسيك، أبواب حمامات مقاومة للماء، أبواب ديكورية فاخرة، وأبواب CNC محفورة" />
        <meta name="keywords" content="منتجاتنا, أبواب WPC, أبواب داخلية, أبواب حمامات, أبواب ديكورية, أبواب CNC, أبواب بدون حلق, أبواب خشبية مركبة" />
        <meta property="og:title" content="منتجاتنا - أبواب WPC | داخلية، حمامات، ديكورية، CNC محفورة" />
        <meta property="og:description" content="تصفح مجموعتنا الواسعة من أبواب WPC: أبواب داخلية كلاسيك، أبواب حمامات مقاومة للماء، أبواب ديكورية فاخرة، وأبواب CNC محفورة" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.newbusiness.com.sa/products" />
        <link rel="canonical" href="https://www.newbusiness.com.sa/products" />
      </Helmet>
      
      <div className="min-h-screen">
        <Navbar />
        
        {/* Hero */}
        <section className="pt-32 pb-16 bg-gradient-to-br from-background via-muted/30 to-background">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center max-w-4xl mx-auto"
            >
              <h1 className="text-5xl md:text-6xl font-bold mb-6">
                <span className="text-gradient">منتجاتنا</span>
              </h1>
              <p className="text-xl text-muted-foreground">
                مجموعة أبواب WPC المتنوعة - الحل المثالي لكل مساحة
              </p>
            </motion.div>
          </div>
        </section>

        {/* Products */}
        <section className="py-24 bg-background">
          <div className="container mx-auto px-4">
            <div className="space-y-24">
                {products.map((product, index) => {
                const isEven = index % 2 === 0;
                // build a Vite-friendly URL to the image specified on the product
                const imgUrl = new URL(`../assets/${product.image}`, import.meta.url).href;
                
                return (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${!isEven ? 'lg:flex-row-reverse' : ''}`}
                  >
                    <div className={isEven ? '' : 'lg:order-2'}>
                      <div className="w-20 h-20 rounded-2xl bg-gradient-primary flex items-center justify-center mb-6 shadow-elegant">
                        <IconLoader name={product.iconName} className="h-10 w-10 text-accent" />
                      </div>
                      <h2 className="text-4xl font-bold mb-4">{product.title}</h2>
                      <p className="text-xl text-muted-foreground mb-6">{product.description}</p>
                      
                      <h3 className="text-2xl font-bold mb-4">المواصفات:</h3>
                      <ul className="space-y-3 mb-8">
                        {product.features.map((feature, idx) => (
                          <li key={idx} className="flex items-start gap-3">
                            <div className="flex-shrink-0 w-2 h-2 rounded-full bg-primary mt-2" />
                            <span className="text-muted-foreground">{feature}</span>
                          </li>
                        ))}
                      </ul>
                      
                      <h3 className="text-2xl font-bold mb-4">الاستخدامات المثالية:</h3>
                      <div className="flex flex-wrap gap-3">
                        {product.uses.map((use, idx) => (
                          <span key={idx} className="px-4 py-2 bg-muted rounded-full text-sm">
                            {use}
                          </span>
                        ))}
                      </div>
                    </div>
                    
                        <div className={isEven ? '' : 'lg:order-1'}>
                          <Card className="p-0 bg-gradient-to-br from-muted/50 to-card hover-lift h-full min-h-[400px] overflow-hidden relative">
                            {
                              (() => {
                                const imgJpg = new URL(`../assets/${product.image}`, import.meta.url).href;
                                const imgWebp = new URL(`../assets/${product.image}.webp`, import.meta.url).href;
                                const imgAvif = new URL(`../assets/${product.image}.avif`, import.meta.url).href;
                                return <ResponsiveImage fill src={imgJpg} webp={imgWebp} avif={imgAvif} alt={product.title} />;
                              })()
                            }
                          </Card>
                        </div>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Customization */}
        <section className="py-24 bg-card">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl font-bold mb-6">
                خيارات <span className="text-gradient">التخصيص</span>
              </h2>
              <p className="text-xl text-muted-foreground">أبوابك بطريقتك، جميع منتجاتنا قابلة للتخصيص بالكامل</p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
              {customization.map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <Card className="p-6 text-center hover-lift h-full">
                    <h3 className="text-xl font-bold mb-3 text-gradient">{item.title}</h3>
                    <p className="text-sm text-muted-foreground">{item.description}</p>
                  </Card>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default Products;
